<template>
  <div>
    <div
      class="search__result-item"
      :class="{ active: isActive }"
    >
      <div
        v-if="item.code == null"
        class="search__result-text"
      >
        <span>Nenhum exame foi encontrado</span>
      </div>
      <div
        v-else
        class="search__result-text"
      >
        <div>
          <span v-html="stringHighlight(item.code, search)" />&nbsp;-&nbsp;<span
            v-html="stringHighlight(item.name, search)"
          />
        </div>

        <div v-if="item.synonym">
          Sinônimos:
          <span>
            <span
              style="color: #7a7a7a"
              v-html="stringHighlight(item.synonym, search)"
            />
          </span>
        </div>

        <span v-else> Sem sinônimos </span>
      </div>

      <div
        v-if="item.code != null"
        class="search__result-details"
        @click.capture.stop="openDetails(item.code)"
      >
        <a
          :id="'detailsLink' + item.code"
          style="display: none"
          :href="$strings.url + '/detalhes?mnemonic=' + item.code"
          target="_blank"
        />
        <div class="search__result-details__anchor">
          <md-icon
            md-src="/static/images/icon-info.svg"
            class="search__result-details__icon"
          />
          <span class="search__result-details__anchor__text">Detalhes</span>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'ExamSearchItem',
  props: {
    item: {},
    search: {},
    isActive: false
  },
  methods: {
    openDetails(code) {
      document.getElementById('detailsLink' + code).click()
    },
    stringHighlight(item, search) {
      if (search !== '' && search.length > 1) {
        var regex = new RegExp('(' + this.processSearchTermToConsiderAccent(search) + ')', 'gi')
        return item.replace(regex, '<strong class="search__result-text__highlight">$1</strong>')
      } else {
        return item
      }
    },
    processSearchTermToConsiderAccent(baseSearch) {
      let processed = baseSearch.toLowerCase()
      processed = processed.replace(/[aáâã]/g, '[aáâãAÁÂÃ]')
      processed = processed.replace(/[eéêẽ]/g, '[eéêẽEÉÊẼ]')
      processed = processed.replace(/[iíîĩ]/g, '[iíîĩIÍÎĨ]')
      processed = processed.replace(/[oóôõ]/g, '[oóôõOÓÔÕ]')
      processed = processed.replace(/[uúûũ]/g, '[uúûũUÚÛŨ]')
      processed = processed.replace(/[cç]/g, '[cçCÇ]')
      return processed
    }
  }
}
</script>
